import { render, staticRenderFns } from "./Front-Footer.vue?vue&type=template&id=559fca44"
import script from "./Front-Footer.vue?vue&type=script&lang=js"
export * from "./Front-Footer.vue?vue&type=script&lang=js"
import style0 from "./Front-Footer.vue?vue&type=style&index=0&id=559fca44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports